import { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { ORGANIZATIONS_PATH } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import { usePagination } from '@app/pages/Sendouts/hooks/usePagination';
import { NotificationContext } from '@app/providers';
import { handleCatchError } from '@app/services';
import { useGetUsersByOrganizationQuery } from '@app/services/rtkQuery/organization';
import type { NOrganization } from '@app/types/Organization';

export const useOrganizationUsers = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { activeBranchId: ActiveBranchId } = useUserPrint();
  const { pageNumber, rowsPerPage, change } = usePagination();

  const organizationId = Number(searchParams.get('id'));

  const [requestData, setRequestData] = useState<NOrganization.GetUsersParams>({
    page: pageNumber,
    pageSize: rowsPerPage,
    organizationId,
    ActiveBranchId,
  });

  const { showNotification } = useContext(NotificationContext);

  const { data, isLoading, error } =
    useGetUsersByOrganizationQuery(requestData);

  useEffect(() => {
    setRequestData((prev) => ({
      ...prev,
      page: pageNumber,
    }));
  }, [pageNumber]);

  useEffect(() => {
    setRequestData((prev) => ({
      ...prev,
      pageSize: rowsPerPage,
    }));
  }, [rowsPerPage]);

  useEffect(() => {
    if (!organizationId) {
      navigate(ORGANIZATIONS_PATH);
    }
  }, [organizationId, navigate]);

  useEffect(() => {
    if (error) {
      showNotification(handleCatchError(error));
    }
  }, [error, showNotification]);

  return {
    data,
    isLoading,
    pageNumber,
    rowsPerPage,
    change,
    setRequestData,
  };
};
